import { render, staticRenderFns } from "./viewObservation.vue?vue&type=template&id=700ecdbc&scoped=true"
import script from "./viewObservation.vue?vue&type=script&lang=js"
export * from "./viewObservation.vue?vue&type=script&lang=js"
import style0 from "./viewObservation.vue?vue&type=style&index=0&id=700ecdbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ecdbc",
  null
  
)

export default component.exports